module.exports = __webpack_public_path__ + "img/thumb_12.d05f8206.jpg";